import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import MainDashboard from '../pages/MainDashboard';
import CompanyLogin from '../pages/CompanyLogin';
import BranchLogin from '../pages/BranchLogin';

const mainRoutes = {
  path: '/',
  element: <CompanyLogin />,
  children: [
    {
      index: true,
      element: <MainDashboard />
    },
    // {
    //   path: 'company-login',
    //   element: <CompanyLogin />
    // },
    // { 
    //   path: 'branch-dashboard',
    //   element: <CompanyLogin />
    //     }
     ]
};

export default mainRoutes;
